import { useEffect, useState } from "react";
import { SolarScene } from "./scene/SolarScene";
import { Sidebar } from "./ui/Sidebar";
import { TopBar } from "./ui/TopBar";
import { InfoCard } from "./ui/InfoCard";
import { TimeBar } from "./ui/TimeBar";
import { Credits } from "./ui/Credits";
import { useScene } from "./store";
import { useT } from "./i18n";

export function App() {
  const { t } = useT();
  const [toast, setToast] = useState(false);
  const lang = useScene((s) => s.lang);
  useEffect(() => { document.documentElement.lang = lang === "en" ? "en" : "zh-CN"; document.title = lang === "en" ? "Solar System 3D" : "太阳系 3D"; }, [lang]);
  useEffect(() => { if (!toast) return; const id = setTimeout(() => setToast(false), 2200); return () => clearTimeout(id); }, [toast]);
  const ask = () => setToast(true);
  return (
    <>
      <SolarScene />
      <Sidebar />
      <TopBar />
      <InfoCard onAsk={ask} />
      <TimeBar />
      <button className="fab glass" onClick={ask}><i />{t("askAi")}</button>
      <Credits />
      {toast && <div className="toast glass">{t("aiSoon")}</div>}
    </>
  );
}
